import { CSSProperties } from "react";
import clsx from "clsx";
import { Slider as RadixSlider } from "@radix-ui/themes";

type Props = {
  value: number;
  values: { label: string; value: number }[];
  min: number;
  max: number;
  step: number;
  className?: string;
  classNameSlider?: string;
  classNameLabel?: string;
  onChange: (value: number) => void;
  style?: CSSProperties;
  styleSlider?: CSSProperties;
};

export default function Slider({
  value,
  values,
  min,
  max,
  step,
  className,
  classNameSlider,
  classNameLabel,
  onChange,
  style,
  styleSlider,
}: Props) {
  const width = 100 / (values.length - 1);

  return (
    <div className={clsx("flex flex-col w-full", className)} style={style}>
      <div className={clsx("flex items-center")}>
        {values.map((item, index) => {
          const isEdges = index === 0 || index === values.length - 1;
          return (
            <div
              key={item.value}
              className={clsx(
                "flex cursor-pointer",
                {
                  "justify-start": index === 0,
                  "justify-end": index === values.length - 1,
                  "justify-center": !isEdges,
                },
                classNameLabel,
              )}
              style={{
                width: isEdges ? `${width / 2}%` : `${width}%`,
              }}
            >
              {item.label}
            </div>
          );
        })}
      </div>
      <RadixSlider
        variant="soft"
        value={[value]}
        min={min}
        max={max}
        step={step}
        onValueChange={(v: number[]) => {
          const newValue = v[0];
          onChange(newValue);
        }}
        className={clsx("cursor-pointer", classNameSlider)}
        style={styleSlider}
      />
    </div>
  );
}
